export const mutationKeys = {
  user: {
    root: () => ['user'],
    patchDriverOptions: () => [...mutationKeys.user.root(), 'patchDriverOptions'],
  },
};
